import type {
  CreateReceiptInput,
  RequisitionDetail,
  RequisitionSuggestion,
  RequisitionTransitionInput,
} from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Records what actually arrived against an order. */
export function recordDelivery(
  requisitionId: number,
  input: CreateReceiptInput,
): Promise<RequisitionDetail> {
  return api.post<RequisitionDetail>(ENDPOINT.requisitionReceipts(requisitionId), input);
}

/** A preview of everything at or below its reorder level — nothing is saved. */
export function suggestRequisitionLines({
  departmentId,
}: {
  departmentId: number | null;
}): Promise<RequisitionSuggestion[]> {
  return api.get<RequisitionSuggestion[]>(
    ENDPOINT.requisitionSuggest,
    departmentId ? { department_id: departmentId } : {},
  );
}

/**
 * Moves a requisition along its ladder.
 *
 * `expected` is the compare-and-set: sending what the screen believes the
 * status to be is what turns "two people approved at once" into one success
 * and one honest conflict.
 */
export function transitionRequisition(
  requisitionId: number,
  input: RequisitionTransitionInput,
): Promise<RequisitionDetail> {
  return api.post<RequisitionDetail>(ENDPOINT.requisitionTransition(requisitionId), input);
}
